import { ComponentProps, type FC } from 'react';
import { FelaCSSWithCustomSelectors } from '@bridebook/ui/src/components/fela/flowtypes';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import Box from '../../../components/fela/Box';
import styles from './bottom-action-bar.style';

type Variant = 'default' | 'sticky-bottom';

interface IProps extends ComponentProps<typeof Box> {
  ignoreSafeArea?: boolean;
  variant?: Variant;
  style?: FelaCSSWithCustomSelectors;
}

const BottomActionBar: FC<IProps> = ({
  children,
  ignoreSafeArea = false,
  style = {},
  variant = 'default',
  ...props
}) => (
  <Box style={mergeStyles([styles.wrapper(ignoreSafeArea, variant), style])} {...props}>
    {children}
  </Box>
);

export default BottomActionBar;
